var select = document.querySelector('#featured-customer-review-slider')

var glide = new Glide('.glide', {
  type: 'carousel',
  perView: 3,
  focusAt: 'center',
  peek: { before: 10, after: 5 },
  breakpoints: {
    600: {
      perView: 1,
      peek: { before: 40, after: 10 },
    },
    980: {
      perView: 2
    }
  }
})


select.addEventListener('change', function (event) {
  glide.update({
    type: event.target.value
  })
})

glide.mount()